<div #canvasParent class="topicviz-parent">
  <div *ngIf="isLoading" class="topicviz-loading">
    <img
      id="wedavinci-logo"
      src="../../../assets/images/logo-no-type.svg"
      alt />
    <div id="loading-div">Computing Layout</div>
  </div>
  <canvas #canvas width="150" height="150"></canvas>

  <div *ngIf="auth.isAdmin" class="adminPanel">
    <div
      class="open-cluster-manager-button btn btn-sm"
      (click)="openClusterManagerModal()">
      Manage Clusters
    </div>
    <div class="toggle-edit btn-group btn-group-sm btn-toggle">
      <button
        class="btn btn-secondary"
        [ngClass]="{
          'btn-primary': !isEditMode,
          active: !isEditMode,
        }"
        (click)="toggleEditMode()">
        <span class="fa fa-eye"></span>
        <span>User</span>
      </button>
      <button
        class="btn btn-secondary btn-sm"
        [ngClass]="{
          'btn-primary': isEditMode,
          active: isEditMode,
        }"
        (click)="toggleEditMode()">
        <span class="fas fa-eye"></span>
        <span>Editor</span>
      </button>
    </div>
    <div class="open-topic-editor btn btn-sm" (click)="openTopicEditModal()">
      Edit Clusters
    </div>
  </div>
  <div
    class="control-button full-screen-button glyphicon"
    (click)="toggleFullScreen()"
    [ngClass]="{
      'glyphicon-resize-full': !isFullScreen,
      'glyphicon-resize-small': isFullScreen,
    }"></div>

  <div class="zoom-buttons">
    <div
      class="zoom-button control-button zoomButtonPlus"
      (click)="onZoomInButtonClicked()">
      +
    </div>
    <div
      class="zoom-button control-button zoomButtonMinus"
      (click)="onZoomOutButtonClicked()">
      -
    </div>
  </div>
</div>
